<template>
  <div>
    <div class="outdoor-pricelist-detail" v-if="!isModalLoading">
      <div v-if="minPeriod && minPeriodUnit" class="outdoor-pricelist-detail__row">
        <div class="subhead">Minimum Order Period</div>
        <h1>{{ pluralize(minPeriod, minPeriodUnit) }}</h1>
      </div>
      <div v-if="leadTime" class="outdoor-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">Lead Time</span>
          <tooltip text="Lead Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey"></i>
            </span>
          </tooltip>
        </div>
        <h1>{{ pluralize(leadTime, 'Day') }}</h1>
      </div>
      <div v-if="trailTime" class="outdoor-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">Trail Time</span>
          <tooltip text="Trail Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey"></i>
            </span>
          </tooltip>
        </div>
        <h1>{{ pluralize(trailTime, 'Day') }}</h1>
      </div>
      <div v-if="reportTime" class="outdoor-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">Report Time</span>
          <tooltip text="Report Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey"></i>
            </span>
          </tooltip>
        </div>
        <h1>{{ pluralize(reportTime, 'Day') }}</h1>
      </div>
      <div v-if="bastTime" class="outdoor-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">BAST Time</span>
          <tooltip text="BAST Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey"></i>
            </span>
          </tooltip>
        </div>
        <h1>{{ pluralize(bastTime, 'Day') }}</h1>
      </div>
      <div v-if="description" class="outdoor-pricelist-detail__description">
        <h1 class="subhead">Description</h1>
        <div class="subhead">{{ description }}</div>
      </div>
      <div v-if="!isModalLoading" class="outdoor-pricelist-detail__tnc">
        <h1 class="subhead">Terms & Condition</h1>
        <ul v-if="terms.length">
          <li class="subhead" v-for="(term, index) in terms" :key="index">{{ term }}</li>
        </ul>
        <div v-else>-</div>
      </div>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";

import { ALoadingPrimary, ATooltip } from "ui-kit-v1";

export default {
  name: "adx-outdoor-placement-detail",
  components: {
    "a-loading": ALoadingPrimary,
    tooltip: ATooltip
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      bottomPrice: null,
      quantity: null,
      minQuantity: null,
      description: null,
      minPeriod: null,
      minPeriodUnit: null,
      lighting: null,
      orientation: null,
      width: null,
      height: null,
      totalSpot: null,
      position: null,
      totalSlot: null,
      duration: null,
      leadTime: null,
      trailTime: null,
      reportTime: null,
      bastTime: null,
      isModalLoading: false,
      terms: []
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      const { data, status } = await api.get(
        restEdge.outdoorPricelistDetail(this.placementId),
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.minPeriod = data.min_period;
        this.minPeriodUnit = data.min_period_unit;
        this.leadTime = data.lead_time;
        this.trailTime = data.trail_time;
        this.description = data.description;
        this.reportTime = data.report_time;
        this.bastTime = data.bast_time;

        if (data.location.tnc && data.location.tnc.length)
          this.terms = data.location.tnc.map(term => term);
      }

      this.isModalLoading = false;
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }

      return `${value} ${label}`;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>